export default "__VITE_ASSET__BMB3ZibM__"